import { read, write } from './_base';
import {
  Billing_Journals_Url,
  Billing_Journal_Url,
  Billing_Journal_Reverse_Url,
} from '../../api/api.endpoints';
import { CreateJournalPayload, JournalEntry, JournalListResponse } from '../../schema/billing/journal';

export const listJournals = (params?: { from?: string; to?: string }) =>
  read<JournalListResponse>(Billing_Journals_Url, 'Failed to load journals', params).then((r) => r.journals ?? []);

export const getJournal = (id: string) => read<JournalEntry>(Billing_Journal_Url(id), 'Failed to load entry');

export const createJournal = (body: CreateJournalPayload) =>
  write<JournalEntry>('post', Billing_Journals_Url, {
    body,
    errorTitle: 'Could not post entry',
    successTitle: 'Journal posted',
    successFallback: 'Balanced entry added to the append-only ledger.',
  });

export const reverseJournal = (id: string, reason_code: string) =>
  write('post', Billing_Journal_Reverse_Url(id), { body: { reason_code }, errorTitle: 'Reversal failed', successTitle: 'Reversal posted' });
